import React from 'react'
import { NotFoundHero } from '../components'
import builder, { Builder, BuilderComponent } from '@builder.io/react'
import '../../builder-settings'
import { useBuilderPage } from '../hooks/builderPage'
import { BuilderSEO } from '../builder/components/seo/seo'
import { LoadingContainer } from '../components/loading-container/loading-container'

builder.init(process.env.GATSBY_BUILDER_IO_API_KEY)

export function NotFound() {
    return (
        <main id="not-found-page">
            <NotFoundHero />
        </main>
    )
}

const NotFoundPage = () => {
    // const [pageNotFound, setPageNotFound] = React.useState(false);
    const {
        model,
        notFound,
        content,
        isContentLoading,
        isEditingOrPreviewingInBuilder,
    } = useBuilderPage()
    // modelName is page by default

    const showNotFound = notFound && !Builder.isEditing && !Builder.isPreviewing // show not found if builder FF is off or if the page not found

    return showNotFound || !isEditingOrPreviewingInBuilder ? (
        <NotFound /> // Your 404 content
    ) : (
        <div className="hero py-0">
            <LoadingContainer isLoading={isContentLoading}>
                <BuilderComponent model={model} content={content} />
            </LoadingContainer>
        </div>
    )
}

export default NotFoundPage

export const Head = ({ location }) => {
    const { title, description, origin } = useBuilderPage()
    const descriptionText = description?.Default || description // Noticed that are times when description is coming as Object and not string
    return (
        <BuilderSEO
            location={location}
            title={`${title}`}
            description={`${descriptionText}`}
            origin={origin}
        />
    )
}
